import { z } from 'zod';

export const AppConfigSchema = z
  .object({
    name: z
      .string({
        error: (issue) =>
          issue.input === undefined
            ? `Please provide the variable NEXT_PUBLIC_PRODUCT_NAME`
            : undefined,
      })
      .describe(`This is the name of your SaaS. Ex. "Makerkit"`)
      .min(1),
    title: z
      .string({
        error: (issue) =>
          issue.input === undefined
            ? `Please provide the variable NEXT_PUBLIC_SITE_TITLE`
            : undefined,
      })
      .describe(`This is the default title tag of your SaaS.`)
      .min(1),
    description: z
      .string({
        error: (issue) =>
          issue.input === undefined
            ? `Please provide the variable NEXT_PUBLIC_SITE_DESCRIPTION`
            : undefined,
      })
      .describe(`This is the default description of your SaaS.`),
    url: z.url({
      message: 'validation:invalidUrl',
    }),
    locale: z
      .string({
        error: (issue) =>
          issue.input === undefined
            ? `Please provide the variable NEXT_PUBLIC_DEFAULT_LOCALE`
            : undefined,
      })
      .describe(`This is the default locale of your SaaS.`)
      .default('en'),
    theme: z.enum(['light', 'dark', 'system']),
    production: z.boolean(),
    themeColor: z.string(),
    themeColorDark: z.string(),
  })
  .refine(
    (schema) => {
      const isCI = process.env.NEXT_PUBLIC_CI;
      const isLocalhost = schema.url.includes('localhost');

      // Skip HTTPS validation for CI, non-production, or localhost builds
      if (isCI || !schema.production || isLocalhost) {
        return true;
      }

      return !schema.url.startsWith('http:');
    },
    {
      message: 'validation:invalidUrl',
      path: ['url'],
    },
  )
  .refine(
    (schema) => {
      return schema.themeColor !== schema.themeColorDark;
    },
    {
      message: 'validation:rules.pleaseProvideDifferentThemeColorsForLight',
      path: ['themeColor'],
    },
  );
